import { NavLink } from 'react-router-dom';

import { routePaths } from '@/app/router/routePaths';
import { cn } from '@/shared/utils/cn';

const LINKS = [
  { to: routePaths.home, label: 'Dashboard' },
  { to: routePaths.tournament.schedule, label: 'Spielplan' },
  { to: routePaths.tournament.groups, label: 'Gruppen' },
  { to: routePaths.tournament.knockout, label: 'KO-Phase' },
  { to: routePaths.team.profile, label: 'Mein Team' },
  { to: routePaths.presentation, label: 'Live-Anzeige' },
] as const;

/**
 * Scrolls sideways on narrow screens instead of collapsing into a menu: at the
 * venue people tap one-handed while holding darts, and a visible row beats a
 * hidden drawer.
 */
export function MainNavigation() {
  return (
    <nav aria-label="Hauptnavigation" className="border-line border-b">
      <ul className="mx-auto flex w-full max-w-6xl gap-1 overflow-x-auto px-2 sm:px-4 lg:px-6">
        {LINKS.map((link) => (
          <li key={link.to}>
            <NavLink
              to={link.to}
              end={link.to === routePaths.home}
              className={({ isActive }) =>
                cn(
                  'touch-target inline-block px-3 py-3 text-sm whitespace-nowrap transition-colors',
                  isActive
                    ? 'border-brand text-fg border-b-2 font-semibold'
                    : 'text-fg-muted hover:text-fg border-b-2 border-transparent',
                )
              }
            >
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
